import { Button, Card, Col, Radio, Row, Space, Typography } from "antd";
import { CheckCircleTwoTone, DeleteOutlined, EditOutlined } from "@ant-design/icons";

const { Text, Paragraph } = Typography;

const QuizQuestionPreview = ({
  index,
  question,
  isPreviewOn,
  userResponses,
  setUserResponses,
  handleEditQuestion,
  handleDeleteQuestion,
}) => {
  return (
    <Card
      key={question?.uid}
      size="small"
      style={{
        borderRadius: 8,
        border: "1px solid #e0e0e0",
        boxShadow: "0 1px 2px #0001",
        width: "100%",
        margin: "24px 0",
      }}
      bodyStyle={{ padding: 24 }}
    >
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Text strong>{question?.question}</Text>
        </Col>
        {isPreviewOn && (
          <Col>
            <Space>
              <Button
                icon={<EditOutlined />}
                size="small"
                onClick={() => handleEditQuestion(index)}
              />
              <Button
                icon={<DeleteOutlined />}
                size="small"
                danger
                onClick={() => handleDeleteQuestion(index)}
              />
            </Space>
          </Col>
        )}
      </Row>
      <Radio.Group
        value={
          userResponses[question.uid] && userResponses[question.uid][0]
            ? userResponses[question.uid][0]
            : null
        }
        onChange={(e) => {
          setUserResponses({
            ...userResponses,
            [question.uid]: [e.target.value],
          });
        }}
        style={{ width: "100%" }}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          {question.options?.map((opt, idx) => (
            <Row
              key={idx}
              align="middle"
              style={{
                border:
                  userResponses[question.uid]?.[0] === opt.text
                    ? "1.5px solid #1890ff"
                    : "1px solid #e0e0e0",
                borderRadius: 4,
                background:
                  userResponses[question.uid]?.[0] === opt.text && opt.isCorrect
                    ? "#f6ffed"
                    : userResponses[question.uid]?.[0] === opt.text
                    ? "#fafafa"
                    : "#fff",
                padding: "6px 12px",
                marginBottom: 8,
                width: "100%",
              }}
            >
              <Col flex="none">
                <Radio value={opt.text} disabled={true} />
              </Col>
              <Col flex="auto" style={{ paddingLeft: 8 }}>
                {opt.text}
              </Col>
              <Col flex="none">
                {opt.isCorrect && (
                  <CheckCircleTwoTone
                    twoToneColor="#52c41a"
                    style={{ marginLeft: 8 }}
                  />
                )}
              </Col>
            </Row>
          ))}
        </Space>
      </Radio.Group>
      {isPreviewOn && (
        <div style={{ marginTop: 16 }}>
          <Paragraph className="mb-1" strong>
            Feedback for incorrect answers
          </Paragraph>
          <div
            style={{
              background: "#fafafa",
              border: "1px solid #e0e0e0",
              borderRadius: 4,
              padding: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>
              {question.explanation || (
                <Text type="secondary">No feedback provided.</Text>
              )}
            </span>
          </div>
        </div>
      )}
    </Card>
  );
};

export default QuizQuestionPreview;
